import React, { useState } from "react";
import NascarProjectionsTable from "./NascarProjectionsTable";
import "./NascarProjectionsPage.css";
import Tabs from "../../../../Tabs";

export default function NascarProjectionsPage() {
  return (
    <div className="nfl-nascar-projections-page-container">
      <br />
      <h1>Nascar Projections</h1>
      <div className="nfl-nascar-projections-table-container">
        <Tabs>
          <React.Suspense fallback="Loading Cup projections..." label="Cup">
            <NascarProjectionsTable series="Cup" />
          </React.Suspense>
          <React.Suspense
            fallback="Loading Trucks projections..."
            label="Trucks"
          >
            <NascarProjectionsTable series="Trucks" />
          </React.Suspense>
          <React.Suspense
            fallback="Loading Xfinity projections..."
            label="Xfinity"
          >
            <NascarProjectionsTable series="Xfinity" />
          </React.Suspense>
        </Tabs>
      </div>
    </div>
  );
}
